{
  "MMM Do YYYY, h:mm a": "D MMM YYYY, h:mm a",
  "MMM Do YYYY": "D MMM YYYY",
  "Wedding": "Boda",
  "Funeral": "Funeral",
  "Birthday": "Cumpleaños",
  "School": "Escuela",
  "Sport": "Deporte",
  "event type|Other": "Otro",
  "Audio/video professional": "Profesional de audio y video",
  "Funeral home owner or director": "Responsable de una funeraria",
  "Event planner or venue manager": "Profesional de eventos o responsable de un salón",
  "Church, pastor, preacher or minister": "Iglesia, pastor, predicador o ministro",
  "Teacher or school manager": "Docente o responsable de una escuela",
  "Nonprofit or charity": "Organización sin fines de lucro o benéfica",
  "Live event streamer or producer": "Transmisión o producción de eventos en vivo",
  "role|Other": "Otro",
  "room noun|room": "sala",
  "room noun|stage": "escenario",
  "room noun|track": "sesión",
  "room noun|court": "cancha",
  "room noun|field": "campo",
  "room noun|hall": "salón",
  "room noun|camera": "cámara",
  "Sorry, we need camera roll permissions to make this work!": "¡Lo sentimos! Necesitamos acceso a tus fotos para que esto funcione.",
  "Streaming Permissions Required": "Se necesitan permisos para transmitir",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "EventLive no puede abrir la transmisión hasta que actives los permisos de cámara, micrófono y grabación.",
  "Search for an event": "Buscar un evento",
  "Schedule your first service": "Programa tu primer servicio",
  "Create your first event": "Crea tu primer evento",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "Cada servicio tiene un enlace privado para compartir con la familia. Las familias lo ven en cualquier dispositivo, sin app ni inicio de sesión.",
  "It looks like you have no events at the moment. Create one to see it here": "Parece que por ahora no tienes eventos. Crea uno para verlo aquí",
  "Schedule a Service": "Programar un servicio",
  "Create an Event": "Crear un evento",
  "You have {count} event credit. Each service day uses one.": {
    "one": "Tienes {count} crédito de evento. Cada día de servicio usa uno.",
    "other": "Tienes {count} créditos de evento. Cada día de servicio usa uno."
  },
  "You have {count} event credit. Each event day uses one.": {
    "one": "Tienes {count} crédito de evento. Cada día de evento usa uno.",
    "other": "Tienes {count} créditos de evento. Cada día de evento usa uno."
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "one": "Tienes {count} evento prepagado. Se usará para este evento.",
    "other": "Tienes {count} eventos prepagados. Se usará uno para este evento."
  },
  "Leave": "Salir",
  "Keep editing": "Seguir editando",
  "Leave without scheduling the service?": "¿Salir sin programar el servicio?",
  "Leave without scheduling the event?": "¿Salir sin programar el evento?",
  "Schedule your live fundraiser": "Programa tu recaudación en vivo",
  "Schedule a service": "Programa un servicio",
  "Schedule your first event": "Programa tu primer evento",
  "Schedule your event": "Programa tu evento",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "Después confirmarás que {organization} es la organización que recibirá las donaciones. Puedes cambiar los detalles más tarde.",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "Después elegirás la organización que recibirá las donaciones. Puedes cambiar los detalles más tarde.",
  "The family gets one private link to watch live or later. You can change the details any time.": "La familia recibe un enlace privado para verlo en vivo o más tarde. Puedes cambiar los detalles cuando quieras.",
  "You can change the details later.": "Puedes cambiar los detalles más tarde.",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "one": "¿Quieres eliminar {title} y su escenario?",
    "other": "¿Quieres eliminar {title} y sus {count} escenarios?"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "one": "¿Quieres eliminar {title} y su sesión?",
    "other": "¿Quieres eliminar {title} y sus {count} sesiones?"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "one": "¿Quieres eliminar {title} y su cancha?",
    "other": "¿Quieres eliminar {title} y sus {count} canchas?"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "one": "¿Quieres eliminar {title} y su campo?",
    "other": "¿Quieres eliminar {title} y sus {count} campos?"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "one": "¿Quieres eliminar {title} y su salón?",
    "other": "¿Quieres eliminar {title} y sus {count} salones?"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "one": "¿Quieres eliminar {title} y su cámara?",
    "other": "¿Quieres eliminar {title} y sus {count} cámaras?"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "one": "¿Quieres eliminar {title} y su sala?",
    "other": "¿Quieres eliminar {title} y sus {count} salas?"
  },
  "Could not delete event": "No se pudo eliminar el evento",
  "Are you sure you want to delete {title}?": "¿Quieres eliminar {title}?",
  "This action cannot be undone.": "Esta acción no se puede deshacer.",
  "Delete Event": "Eliminar evento",
  "Deleting Event...": "Eliminando evento...",
  "Delete {camera}": "Eliminar {camera}",
  "How to Go Live": "Cómo transmitir en vivo",
  "Guest List & Invite": "Lista de invitados e invitaciones",
  "Title, Date, Time, Event Link, Uploads": "Título, fecha, hora, enlace y archivos",
  "Add Another Camera Angle": "Agregar otro ángulo de cámara",
  "Add a Room, Stage or Track": "Agregar sala, escenario o sesión",
  "Chat": "Chat",
  "Privacy Settings": "Configuración de privacidad",
  "Event Branding": "Marca del evento",
  "Event Analytics": "Estadísticas del evento",
  "Expiring soon": "Vence pronto",
  "Storage expiry": "Vencimiento del almacenamiento",
  "You're invited to watch {title}": "Te invitamos a ver {title}",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "Los invitados usan tu enlace principal y ahí cambian a esta cámara. Transmítela desde su propio teléfono.",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "Comparte este enlace: los invitados cambian de cámara mientras ven la transmisión. Cada cámara transmite desde su propio teléfono.",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "Los invitados usan el enlace principal y cambian de {noun} en la página del evento. Esta transmisión tiene su propia clave.",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "Comparte este enlace: los invitados cambian de {noun} en la página del evento. Cada {noun} transmite con su propia clave.",
  "Your event link:": "Enlace de tu evento:",
  "{days}-day event:  Unlock with {count} more credit": {
    "one": "{days} días: desbloquear con {count} crédito más",
    "other": "{days} días: desbloquear con {count} créditos más"
  },
  "Unlock with {count} credit": {
    "one": "Desbloquear con {count} crédito",
    "other": "Desbloquear con {count} créditos"
  },
  "{days}-day event: Unlock with {count} prepaid events": "{days} días: desbloquear con {count} eventos prepagados",
  "{days}-day event: Unlock with your prepaid event": "{days} días: desbloquear con tu evento prepagado",
  "Unlock with {count} prepaid events": "Desbloquear con {count} eventos prepagados",
  "Unlock with your prepaid event": "Desbloquear con tu evento prepagado",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "Tu enlace privado del evento vencerá el {date}. Mantén la página del evento, el video y el libro de visitas en línea 1 año más o durante 10 años.",
  "Keep My Memories Online Longer": "Mantener mis recuerdos en línea más tiempo",
  "Download & View Stats": "Descargar y ver estadísticas",
  "This Event is in the Secure Archive.": "Este evento está en el archivo seguro.",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "Terminó el periodo de transmisión pública de este evento. El enlace de transmisión venció, pero los recuerdos están a salvo en nuestro archivo.",
  "Restore this Event": "Restaurar este evento",
  "Unlock cameras": "Desbloquear cámaras",
  "{days}-Day Event: {start} – {end}": "Evento de {days} días: {start} – {end}",
  "Expires in {count} day": {
    "one": "Vence en {count} día",
    "other": "Vence en {count} días"
  },
  "Event is in the Secure Archive": "El evento está en el archivo seguro",
  "Extend": "Extender",
  "Use credit": "Usar crédito",
  "Use prepaid event": "Usar evento prepagado",
  "Could not unlock the event": "No se pudo desbloquear el evento",
  "Pay As You Go": "Pago por uso",
  "Couldn't schedule the service": "No se pudo programar el servicio",
  "Couldn't schedule the event": "No se pudo programar el evento",
  "Service title": "Título del servicio",
  "e.g. Celebration of Life for Jane Doe": "p. ej., Homenaje a María López",
  "e.g. Anna & Mark's wedding": "p. ej., Boda de Ana y Marcos",
  "your-event-link": "tu-evento",
  "Available": "Disponible",
  "Event type": "Tipo de evento",
  "Choose the type of event": "Elige el tipo de evento",
  "When the service starts": "Cuándo empieza el servicio",
  "When the event starts": "Cuándo empieza el evento",
  "Make it a multi-day event": "Convertir en evento de varios días",
  "Raise donations for a nonprofit": "Recaudar donaciones para una organización sin fines de lucro",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "Los espectadores pueden donar en la página de tu evento. Elegirás la organización después de crear el evento.",
  "Schedule service": "Programar servicio",
  "Schedule event": "Programar evento",
  "Event details": "Detalles del evento",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room} usa la fecha, la hora y los días del evento principal. Cámbialos ahí y cada {noun} se ajustará también.",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "Los cambios que hagas aquí se aplican a cada {noun}. Los días extra se cobran por {noun}.",
  "Title and location": "Título y ubicación",
  "Test events keep their name.": "Los eventos de prueba conservan su nombre.",
  "e.g. St. Mary's Church, Austin": "p. ej., Parroquia de Santa María, Guadalajara",
  "Links and files": "Enlaces y archivos",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "Se muestran debajo del video en la página de tu evento: una mesa de regalos, una página de donaciones, un sitio web o un programa.",
  "Event rescheduled": "Evento reprogramado",
  "Guests will see the new date.": "Los invitados verán la nueva fecha.",
  "Couldn't change the date": "No se pudo cambiar la fecha",
  "Event date and time": "Fecha y hora del evento",
  "Choose the event's local date and time": "Elige la fecha y la hora locales del evento",
  "Save date and time": "Guardar fecha y hora",
  "Change Link": "Cambiar enlace",
  "Change event link?": "¿Cambiar el enlace del evento?",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "Si ya compartiste el enlace actual con tus invitados, ya no podrán entrar al evento con el enlace anterior. ¿Quieres continuar?",
  "Event link changed": "Enlace del evento cambiado",
  "Couldn't change the link": "No se pudo cambiar el enlace",
  "Share this link with your guests.": "Comparte este enlace con tus invitados.",
  "your-event-name": "nombre-de-tu-evento",
  "Copy event link": "Copiar enlace del evento",
  "Guests who already have the old link won't be able to open the event with it.": "Los invitados que ya tienen el enlace anterior no podrán abrir el evento con él.",
  "Change link": "Cambiar enlace",
  "Edit {title}": "Editar {title}",
  "Edit link": "Editar enlace",
  "Add a name": "Agrega un nombre",
  "Add a web address": "Agrega una dirección web",
  "Open {title}": "Abrir {title}",
  "Open link": "Abrir enlace",
  "Remove {title}": "Quitar {title}",
  "Remove link": "Quitar enlace",
  "File name guests see": "Nombre del archivo que verán los invitados",
  "Link text": "Texto del enlace",
  "e.g. Order of service": "p. ej., Programa de la ceremonia",
  "e.g. Our registry": "p. ej., Nuestra mesa de regalos",
  "Web address": "Dirección web",
  "Add link": "Agregar enlace",
  "File added": "Archivo agregado",
  "Guests can open it from the event page.": "Los invitados pueden abrirlo desde la página del evento.",
  "Removed \"{title}\"": "Se quitó “{title}”",
  "Removed \"link\"": "Se quitó el enlace",
  "Tap to undo": "Toca para deshacer",
  "Uploading…": "Subiendo…",
  "Upload file": "Subir archivo",
  "file type|Text": "Texto",
  "file type|Image": "Imagen",
  "file type|File": "Archivo",
  "Document": "Documento",
  "Add the text guests will see.": "Agrega el texto que verán los invitados.",
  "Add the web address.": "Agrega la dirección web.",
  "Enter an address like zola.com/registry or an email.": "Escribe una dirección como zola.com/registry o un correo electrónico.",
  "Multi-Day event?": "¿Evento de varios días?",
  "Days": "Días",
  "Timezone: {timezone}": "Zona horaria: {timezone}",
  "Search timezone...": "Buscar zona horaria...",
  "Select timezone": "Selecciona la zona horaria",
  "MMMM D, yyyy h:mm a": "D [de] MMMM [de] YYYY, h:mm a",
  "dddd, MMMM D, YYYY": "dddd, D [de] MMMM [de] YYYY",
  "ddd, MMM D": "ddd D MMM",
  "Start Time": "Hora de inicio",
  "Event Date and Local Time": "Fecha y hora local del evento",
  "Event Date": "Fecha del evento",
  "Select": "Seleccionar",
  "date picker|Choose": "Elegir",
  "date picker|Not available": "No disponible",
  "date picker|Month": "Mes",
  "date picker|Previous Month": "Mes anterior",
  "date picker|Next Month": "Mes siguiente",
  "EEEE, MMMM d, yyyy": "EEEE, d 'de' MMMM 'de' yyyy",
  "Start time": "Hora de inicio",
  "h:mm aa": "h:mm aa",
  "date picker|time": "hora",
  "MMMM d, yyyy h:mm aa": "d 'de' MMMM 'de' yyyy, h:mm aa",
  "EEE, MMM d": "EEE d MMM",
  "Hide the event page? Guests won't be able to open it.": "¿Ocultar la página del evento? Los invitados no podrán abrirla.",
  "Hide the event page?": "¿Ocultar la página del evento?",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "one": "Quienes compraron boletos no podrán ver la transmisión en vivo ni la grabación hasta que vuelvas a mostrar la página. {count} persona de tu lista de invitados perderá el acceso.",
    "other": "Quienes compraron boletos no podrán ver la transmisión en vivo ni la grabación hasta que vuelvas a mostrar la página. {count} personas de tu lista de invitados perderán el acceso."
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "Quienes compraron boletos no podrán ver la transmisión en vivo ni la grabación hasta que vuelvas a mostrar la página.",
  "{days}-Day Event: {start}": "Evento de {days} días: {start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "Este evento aún no está desbloqueado. Pídele a un administrador de la cuenta de {team} que lo desbloquee.",
  "Couldn't load {team}'s events. Try again.": "No se pudieron cargar los eventos de {team}. Inténtalo de nuevo.",
  "Switch to my account": "Cambiar a mi cuenta",
  "No events yet": "Aún no hay eventos",
  "Events in {team}'s account will show up here.": "Aquí aparecerán los eventos de la cuenta de {team}.",
  "Event unlocked": "Evento desbloqueado",
  "Couldn't unlock this event": "No se pudo desbloquear este evento",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "Es posible que la cuenta de {team} no tenga créditos suficientes. Pídele al titular de la cuenta que agregue más."
}
